<template>
  <Badge :value="OrgName" :style="{'background-color':'#ff5722'}"></Badge>
</template>

<script>
  import Badge from 'primevue/badge';

    export default  {
    name: 'RenderOrgName',
    components: {
      Badge
    },
    data: () => ({
        OrgName:''
    }),
        created() {
             this.OrgName = this.params.value;
        }
    };
</script>